import styled from "styled-components";

export const PageContent = styled.div`
    min-height: 80vh;
    background-color: #ffffff;
    padding: 24px;
    margin-top: 30px;
`;